import { useCallback } from "react";
import { Box, Checkbox } from "@mantine/core";
import MaterialPickerBlockRow, { BlockInfo } from "./MaterialPickerBlockRow";

export interface SpecimenInfo {
  id: string;
  number: string;
  source?: {
    id: string;
    name: string;
  } | null;
  blocks?: BlockInfo[];
}

interface MaterialPickerSpecimenRowProps {
  specimen: SpecimenInfo;
  selectedSlideIds: Set<string>;
  isAllSelected: boolean;
  isPartiallySelected: boolean;
  isBlockFullySelected: (blockId: string) => boolean;
  isBlockPartiallySelected: (blockId: string) => boolean;
  onToggleSpecimen: (specimenId: string) => void;
  onToggleBlock: (blockId: string) => void;
  onToggleSlide: (slideId: string) => void;
}

export default function MaterialPickerSpecimenRow({
  specimen,
  selectedSlideIds,
  isAllSelected,
  isPartiallySelected,
  isBlockFullySelected,
  isBlockPartiallySelected,
  onToggleSpecimen,
  onToggleBlock,
  onToggleSlide,
}: MaterialPickerSpecimenRowProps) {
  const handleSpecimenChange = useCallback(() => {
    onToggleSpecimen(specimen.id);
  }, [onToggleSpecimen, specimen.id]);

  return (
    <Box mb="xs">
      <Checkbox
        label={`Specimen ${specimen.number}${
          specimen.source?.name ? `: ${specimen.source.name}` : ""
        }`}
        size="sm"
        fw={600}
        mb={4}
        checked={isAllSelected}
        indeterminate={isPartiallySelected}
        onChange={handleSpecimenChange}
      />
      {specimen.blocks?.map((block) => (
        <MaterialPickerBlockRow
          key={block.id}
          block={block}
          selectedSlideIds={selectedSlideIds}
          isFullySelected={isBlockFullySelected(block.id)}
          isPartiallySelected={isBlockPartiallySelected(block.id)}
          onToggleBlock={onToggleBlock}
          onToggleSlide={onToggleSlide}
        />
      ))}
    </Box>
  );
}
